import React from "react";
import LinearProgress from '@material-ui/core/LinearProgress';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
    linearProgressRoot: {
        height: 10,
        borderRadius: 3
    }
}));

const ProgressComponent = () => {
    const classes = useStyles();

    return (
        <div style={{width: '100%', height: '100%'}}>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                    <LinearProgress
                        variant="determinate"
                        value={50}
                        classes={{root: classes.linearProgressRoot}}
                    />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="textSecondary">{`${Math.round(
                        50,
                    )}%`}</Typography>
                </Box>
            </Box>
        </div>

    )
};

export default ProgressComponent